import type { LorsCopy } from "./translations";

const LorsFooter = ({ copy }: { copy: LorsCopy }) => (
  <footer
    className="py-6 border-t"
    style={{
      backgroundColor: "hsl(0 0% 100%)",
      borderColor: "hsl(199 21% 86%)",
    }}
  >
    <div className="container max-w-[1320px] mx-auto px-6 flex flex-col sm:flex-row items-center justify-between gap-2 text-sm">
      <p style={{ color: "hsl(210 24% 35%)" }}>{copy.footerCopyright}</p>
      <a
        href="http://lawofficeofruby.com/privacy-policy"
        target="_blank"
        rel="noopener noreferrer"
        className="underline"
        style={{ color: "hsl(210 24% 35%)" }}
      >
        {copy.footerPrivacy}
      </a>
    </div>
  </footer>
);

export default LorsFooter;
